<template>
  <div>
    <div
      v-if="!chapterSelectionMode"
      class="hover-pointer d-flex-column-center"
      @click="$emit('click')"
    >
      Modifier les milieux pour lesquels vous souhaitez faire l'autodiagnostic
    </div>
    <div v-else class="d-flex justify-content-end">
      <button
        class="btn btn-sm btn-secondary"
        type="reset"
        :disabled="form.processing"
        @click="$emit('cancel')"
      >
        Annuler
      </button>
      <button
        class="ms-2 btn btn-sm btn-primary"
        type="submit"
        :disabled="disableSaveButton"
        @click="$emit('save')"
      >
        Sauvegarder
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chapterSelectionMode: Boolean,
    isUpdated: Boolean,
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    disableSaveButton() {
      return (
        this.form.processing ||
        !this.isUpdated ||
        this.form.chapter_ids.length === 0
      )
    },
  },
}
</script>

